












import {
  Component,
  Vue,
  SectionType,
  Advisor,
  Prop,
  BaseRecommendation
} from "@zoovu/runner-browser-api";
import {StartOverButtonView} from "@zoovu/runner-web-design-base";
import {State} from "vuex-class";

@Component({
  name: "StartOverButtonView",
  mixins: [StartOverButtonView]
})
export default class StartOverButtonViewExtended extends Vue {
  @Prop()
  advisor!: Advisor;

  @State
  numberOfProducts!: number;

  @State
  showResultCount!: boolean;

  @State
  showResultsCountOnQuestionnaire!: boolean;

  get areProductsAvailable() {
    return this.advisor.advice.hasProducts;
  }

  get shouldResultsCounterBeShown() {
    if (this.showResultCount) {
      return !(
        this.advisor.advisorNavigation.currentSection.type === SectionType.QUESTIONNAIRE &&
        !this.showResultsCountOnQuestionnaire
      );
    }
    return false;
  }

  get shouldRender() {
    return (
      !this.advisor.flowStepsNavigation.currentFlowStep.questions[0].isUnanswered ||
      this.advisor.flowStepsNavigation.currentStepIndex
    );
  }

  get justifyingClass() {
    return !this.shouldResultsCounterBeShown ? "toRight" : "";
  }

  get advice(): BaseRecommendation {
    return this.advisor.advice;
  }

}
